module.exports = __webpack_public_path__ + "static/img/cooperation_banner.9b498093.png";